import { useState } from 'react'

import Box from '@mui/material/Box'
import ShrimpTopupRecordCard from '../ShrimpTopupRecordCard'
import ShrimpTopupRecordBodyCycle from '../ShrimpTopupRecordBodyCycle'
import ShrimpTopupRecordBodyTopup from '../ShrimpTopupRecordBodyTopup'
import {
  Grid,
} from '@mui/material'
import { useGetShrimpTopup } from 'modules/shrimpTopup/api/queries'
import ShrimpTopupRecordBodyTopupSkeleton from '../ShrimpTopupSkeleton'


const ShrimpTopupRecord = () => {
  const { data, isLoading } = useGetShrimpTopup()
  return (
    <Box>
      <ShrimpTopupRecordCard>
        <Grid container spacing={2}>
          {isLoading ? (
            [1, 2, 3, 4].map((index: number) => (
              <Grid item sm={12} md={6} xl={3} key={index}>
                <ShrimpTopupRecordBodyTopupSkeleton />
              </Grid>
            ))
          ) : (
            <>
              <ShrimpTopupRecordBodyTopup
                topupsData={data?.topups || []}
              />
              <ShrimpTopupRecordBodyCycle
                cycleData={data?.cycle ?? null}
              />
            </>
          )}
        </Grid>
      </ShrimpTopupRecordCard>
    </Box>
  )
}

export default ShrimpTopupRecord
